export default {
    name: 'Dot',
    dimensions: { width: 10, height: 10 },
    content: `
    <circle cx="5" cy="5" r="4" fill="currentColor" stroke="currentColor" stroke-width="2"/>
  `
};
